<template>
    <div class="row">
        <div class="h5 col-md-6 heading-orange mt-3">
            5.　BCPの運用
        </div>
        <div class="p2 mt-3 ms-auto col-md-2 d-flex align-items-center justify-content-center ">
            <input type="button" class="btn btn-black" value="前ページへ戻る" @click="showBack" :disabled="isProcessing">
        </div>
    </div>

    <levelIcon
        :set_level="setLevel"
    />

    <div class="row ms-3 mt-3">
        <div class="p2 col-md d-flex align-items-center justify-content-start py-2 font-orange">
        BCPの定着　―――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――
        </div>
    </div>

    <div class="row ms-3 mt-3">
        <div class="p2 col-md d-flex align-items-center justify-content-start py-2">
            BCPは、策定して終わりではありません。緊急事態になった時に{{callReplaceWord('従業員')}}がBCPを有効に活用し、適切な対応ができるよう準備しておくことではじめて意味を成します。<br>
            そのため、BCPを策定した後は、{{callReplaceWord('従業員')}}にBCPの内容やその重要性を理解してもらうために、{{callReplaceWord('社内')}}における教育活動を実施することが重要となります。<br>
            教育計画では、誰が、いつ、何を行うのかを入力してください。
        </div>
        <div class="p2 ms-4 col-md-1 d-flex align-items-start justify-content-start">
            <VDropdown
                    theme="hint-theme"
                >
                    <input type="button" class="btn btn-sm btn-hint rounded-0 text-nowrap" value="ヒント">
                    <template #popper>
                        <div class="row">
                            <label>
                                BCPを考えることは、「災害時の事業継続」だけの話ではなく、日常の業務を見直すことそのものです。<br>
                                BCPを通じて事業を見直すことで、事業のボトルネックや弱点、長所などが見える化され、自然災害以外の危機（{{callReplaceWord('取引先')}}の倒産など）でも無理なく対応できるようになります。
                                BCPの定着とは、BCPを通じて、日常の業務の見直し、特性の見える化と改善を行うことを意味しています。
                                BCP策定後、{{callReplaceWord('従業員')}}にBCPの内容や重要性を理解してもらうために、{{callReplaceWord('社内')}}教育活動を実施することが重要となります。<br>
                                少なくとも年1回以上は{{callReplaceWord('経営者')}}が{{callReplaceWord('従業員')}}に対してBCPの進捗状況や問題点を説明するとともに、各自の取組状況、役割分担を定期的に確認することをお勧めします。</label>
                        </div>
                    </template>
            </VDropdown>
        </div>
    </div>

    <div class="row ms-3 mt-5">
        <div class="p2 col-md-5 border bg-sub-title d-flex align-items-center justify-content-start py-2">
            ◯　教育計画
        </div>
    </div>
    <div v-for="(form, formIndex) in valueForms" :key="formIndex">

        <div class="row ms-3 mt-3">
            <div class="p2 col-md-10 border bg-one-set border-dark border-bottom-0 d-flex align-items-center justify-content-center py-2">
            </div>
        </div>

        <div class="row ms-3">
            <div class="p2 col-md-4 border bg-one-set border-dark border-top-0 border-bottom-0 border-end-0 d-flex align-items-center justify-content-start py-2">
                誰がやりますか？
            </div>
            <div class="p2 col-md-1 bg-one-set d-flex align-items-center justify-content-center py-2" >
            </div>
            <div class="p2 col-md-4 bg-one-set d-flex align-items-center justify-content-start py-2">
                いつやりますか？（どのくらいの頻度で？）
            </div>
            <div class="p2 col-md-1 border bg-one-set border-dark border-start-0 border-top-0 border-bottom-0 d-flex align-items-center justify-content-center py-2">
            </div>
            <div class="p2 ms-4 col-md-1 d-flex align-items-start justify-content-start" v-if="formIndex === 0">
                <VDropdown
                    theme="hint-theme"
                >
                    <input type="button" class="btn btn-sm btn-hint rounded-0 text-nowrap" value="ヒント">
                    <template #popper>
                        <div class="row">
                            <label>
                                【教育活動の例】<br>
                                ■業務の内容について、定期的に状況把握を行う（クリティカルパスになっている事象は前回と同様か、など）<br>
                                ■毎年1回以上、{{callReplaceWord('経営者')}}が{{callReplaceWord('従業員')}}に対してBCPの進捗状況や問題点を説明する<br>
                                ■{{callReplaceWord('従業員')}}各自がBCPの取組状況、役割分担の定期的な確認を行う<br>
                                ■策定したBCPのポイントに関する{{callReplaceWord('社内')}}研修会を開催する<br>
                                ■BCPの内容等に関する{{callReplaceWord('社内')}}掲示を実施する
                            </label>
                        </div>
                    </template>
                </VDropdown>
            </div>
        </div>

        <div class="row ms-3">
            <div class="p2 col-md-4 border bg-one-set border-dark border-top-0 border-bottom-0 border-end-0 d-flex align-items-center justify-content-start">
                <select name="selectAdminCandidate" class="form-select" v-model="form.values[0].value">
                    <option type="text" v-for="adminCandidate in admin_candidate_list" :value="adminCandidate.氏名" >{{ adminCandidate.氏名 }}</option>
                </select>
            </div>

            <div class="p2 col-md-1 bg-one-set d-flex align-items-center justify-content-center py-2">
            </div>
            <div class="p2 col-md-4 bg-one-set d-flex align-items-center justify-content-start py-2">
                <input type="text" class="form-control d-flex align-items-center justify-content-start py-2" placeholder=""
                v-model="form.values[1].value">
            </div>
            <div class="p2 col-md-1 border bg-one-set border-dark border-start-0 border-top-0 border-bottom-0 d-flex align-items-center justify-content-center py-2">
            </div>
            <div class="p2 ms-4 col-md-1 d-flex align-items-start justify-content-start" v-if="formIndex !== 0">
                <input type="button" class="btn btn-delete" value="削除" @click="deleteLine(formIndex)">
            </div>
        </div>

        <div class="row ms-3">
            <div class="p2 col-md-10 border bg-one-set border-dark border-top-0 border-bottom-0 d-flex align-items-center justify-content-start py-2">
                何をやりますか？
            </div>
        </div>

        <div class="row ms-3">
            <div class="p2 col-md-10 border bg-one-set border-dark border-top-0 border-bottom-0 d-flex align-items-center justify-content-start">
                <input type="text" class="form-control d-flex align-items-center justify-content-start py-2" placeholder=""
                v-model="form.values[2].value">
            </div>
            <div class="p2 ms-4 col-md-1 d-flex align-items-start justify-content-start" v-if="formIndex === valueForms.length - 1">
                <input type="button" class="btn btn-black" value="ワンセット増やす" @click="addLine">
            </div>
        </div>

        <div class="row ms-3">
            <div class="p2 col-md-10 border bg-one-set border-dark border-top-0 d-flex align-items-center justify-content-center py-2">
                &emsp;
            </div>
        </div>
    </div>

    <div class="row ms-3 mt-5">
        <div id="a" class="p2 col-md d-flex align-items-center justify-content-start py-2 font-orange">
        BCPの見直し　――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――
        </div>
    </div>

    <div class="row ms-3 mt-3">
        <div class="p2 col-md d-flex align-items-center justify-content-start py-2">
            常に BCPの内容をあなたの{{callReplaceWord('組織')}}の現状に見合ったものとしておくために、必要に応じBCPの見直しを行うことが重要となります。BCPの見直しは、日頃からあなたの{{callReplaceWord('組織')}}が実施している{{callReplaceWord('経営')}}管理の延長にあるものとして、随時確認するようにしましょう。
        </div>
        <div class="p2 ms-4 col-md-1 d-flex align-items-start justify-content-start">
            <VDropdown
                    theme="hint-theme"
                >
                    <input type="button" class="btn btn-sm btn-hint rounded-0 text-nowrap" value="ヒント">
                    <template #popper>
                        <div class="row">
                            <label>
                                BCPの内容は現状に見合ったものとしておくために、必要に応じ 見直しを行うことが重要です。<br>
                                経営管理の延長にあるものと考え、見直す基準を検討してください。例えば、災害シナリオ（ある想定災害）について、どのような状況が起きるかのイメージを{{callReplaceWord('従業員')}}全員で共有し、BCPでそれに対してどこまで対応できるか、どこが対応できないかを洗い出すなど、BCPの実効性について検証、見直しましょう。これは、訓練（図上を含む）を通じて検証すると効果的です。
                            </label>
                        </div>
                    </template>
                </VDropdown>
        </div>
    </div>

    <div id="a" class="row ms-3 mt-5">
        <div class="p2 col-md-5 bg-sub-title d-flex align-items-center justify-content-start py-2">
            ◯　BCPを見直す基準
        </div>
    </div>

    <div class="row ms-3 mt-3">
        <div class="col-md-10">
            あなたの{{ callReplaceWord("組織") }}のBCPを見直す基準として合致するものがあれば、それをすべて選択してください。<br>
            なお、選択肢は例示ですので、明確な役割がある場合は、「その他」の欄にご入力ください。
        </div>
        <div class="col-md-2">
            <VDropdown
                theme="hint-theme"
            >
                <input type="button" class="btn btn-sm btn-hint rounded-0 text-nowrap" value="ヒント">
                <template #popper>
                    <div class="row">
                        <label>
                            {{callReplaceWord('顧客')}}状況や在庫状況等に大幅な変更があった場合、{{callReplaceWord('商品')}}・サービスの変更・追加、生産ラインの組み替え、人事異動等があった場合は、BCPの見直しを行う必要があるか検討し、その必要があればBCPに反映します。
                            その他、以下のような状況もBCPの見直しを行うか検討し、必要に応じてBCPに反映します。<br>
                            ■定期的に実施する事業内容の確認の中で、クリティカルパス（代替できない{{callReplaceWord('取引先')}}など）の状況に変化があったり、その対応方策の選択肢が変化したとき<br>
                            ■被災シナリオに基づくBCPの実効性確認（訓練など）の結果、対応できない事象が明らかになったとき<br>
                            また、事前対策の進捗状況や問題点をチェックし、必要に応じてBCPを見直すこともお勧めします。
                        </label>
                    </div>
                </template>
            </VDropdown>
        </div>
    </div>

    <div class="row ms-3 mt-3">
        <div v-for="(form, formIndex) in textForms" :key="formIndex" class="d-flex flex-column">
            <button class="btn border btn-light text-dark btn-sm text-left flex-fill mt-3" :class="{ 'button-selected': textForms[formIndex].isSelected }" @click="selectedStandard(formIndex)">
                <span class="first-line">{{ form.value }}</span><br>
                <span class="second-line">{{ form.body }}</span>
            </button>
        </div>
    </div>
    <div class="row ms-3 mt-3">
        <div class="col-3 d-flex flex-column">
            <label class="border flex-fill bg-other-title ps-2 centered">その他</label>
            <!-- <button class="btn border btn-light text-dark btn-sm text-left flex-fill" :class="{ 'button-selected': btnOther }" @click="selectBtnOther">
                <span class="first-line">その他</span><br>
            </button>         -->
        </div>
        <div class="col-9">
            <textarea class="form-control flex-fill" v-model="textOther" rows="4"></textarea>
        </div>
    </div>

    <!-- <div v-for="(form, formIndex) in textForms" :key="formIndex">
        <button class="btn  border btn-light text-dark btn-sm text-left" :class="{ buttoncolor: textForms[1].isSelected }">
            <span class="first-line">{{ form.value }}</span><br>
            <span class="second-line">{{ form.body }}</span>
        </button>
        <div class="row ms-3 mt-3">
            <div class="row col-md-10">
                <textarea type="text" rows="3" class="form-control d-flex align-items-center justify-content-center py-2"
                    placeholder="" v-model="form.value"></textarea>
            </div>
            <div class="p2 ms-4 col-md-1 d-flex align-items-start justify-content-start" v-if="formIndex == 0">
            </div>
        </div>
    </div> -->

    <div class="row ms-3 mt-5">
        <div class="p2 ms-3 col-md d-flex align-items-center justify-content-around">
            <input type="button" class="btn btn-bcp-introduction" :value="confirm_button_label" @click="showIntroductionComplete" :disabled="isProcessing">
        </div>
        <div class="p2 col-md d-flex align-items-center justify-content-around">
            <input type="button" class="btn btn-bcp-introduction" value="目次構成 へ戻る" @click="showContents" :disabled="isProcessing">
        </div>
    </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue'
import levelIcon from '../../common/UserLevelIconsComponent.vue'
import ReplaceWord from '../../../function/CommonReplaceWord'
const { getReplaceWord } = ReplaceWord();
import axios from 'axios';

export default {
    components: {
        levelIcon,
    },
    setup(props) {
        onMounted(async() => {
            // 取得データをセット
            let isExistValueForm = false;
            if(props.bcp_introduction_values_info.length > 0) {
                await props.bcp_introduction_values_info.forEach(data => {
                    if(
                        columnNameRegex.test(data.column_name)
                        && parseInt(data.column_name.substring(1)) >= 56
                        && !valueForms.value.some(val => val.columnName == data.column_name)
                        && data.column_name !== "N10061"
                    ) {
                        // 同一カラムのvalue値を取得
                        const findDataSeq1 = props.bcp_introduction_values_info.find(fetchData => {
                            return fetchData.column_name === data.column_name && fetchData.seq === 1
                        });
                        // 同一カラムのvalue値を取得
                        const findDataSeq2 = props.bcp_introduction_values_info.find(fetchData => {
                            return fetchData.column_name === data.column_name && fetchData.seq === 2
                        });
                        const findDataSeq3 = props.bcp_introduction_values_info.find(fetchData => {
                            return fetchData.column_name === data.column_name && fetchData.seq === 3
                        });
                        valueForms.value.push({
                            columnName: data.column_name,
                            values:[
                                {value: typeof findDataSeq1 !== 'undefined' ? findDataSeq1.value : ''},
                                {value: typeof findDataSeq2 !== 'undefined' ? findDataSeq2.value : '' },
                                {value: typeof findDataSeq3 !== 'undefined' ? findDataSeq3.value : '' },
                            ]
                        });

                        valueToColumnName = data.column_name;
                        isExistValueForm = true;
                    }

                    if(data.column_name === "N10061"){
                        const wkTextForm = textForms.find(item => item.columnName === data.column_name && item.seq === data.seq);
                        wkTextForm.isSelected = true;
                    }

                });

                if(props.bcp_basic_frame_info.入門確定日){
                    confirm_button_label.value = "次版作成年月日へ";
                }
            }
            if (!isExistValueForm) {
                // 既存のデータが存在しない場合は初期データを投入する
                valueForms.value = [...valueFormsInitialData];
            }

            if(props.bcp_introduction_texts_info.length > 0) {
                props.bcp_introduction_texts_info.forEach(data => {
                    // textForms.forEach((initData, index) => {
                    //     if(data.column_name === initData.columnName) {
                    //         initData.isSelected = true;
                    //         // textForms.splice(index, 1, {
                    //         //     columnName: data.column_name,
                    //         //     value: data.text_value
                    //         // });
                    //     }
                    // });

                    if(data.column_name === "N00061" || data.column_name === "N00062" || data.column_name === "N00063"){
                        if(textOther.value.length === 0){
                            textOther.value = data.text_value;
                        }else{
                            textOther.value = textOther.value + "\r\n" + data.text_value;
                        }
                    }
                });
            }
        });

        // 戻るボタン制御
        if (sessionStorage.getItem('refresh') == 'true') {
            sessionStorage.removeItem('refresh');
            window.location.reload();
        }

        // ターゲット指定制御
        setTimeout(() => {
            const urlHash = location.hash;
            if (urlHash) {
                const url = urlHash.split('#');
                location.href = '#' + url[1];
            }
        }, 1000);

        const setLevel = ref('100000');
        const isProcessing = ref(false);
        const selectAdminCandidate = ref('');
        const columnNameRegex = new RegExp(`^N[0-9]{5}$`);
        let valueToColumnName = 'N00059';

        const callReplaceWord = (word) => {
            return getReplaceWord(word, props.replacement_word_list)
        }

        const textForms = reactive([
            {
                columnName: 'N10061',
                value: "定期的な見直し",
                body: "毎年1回以上、事前対策の進捗状況や問題点をチェックし、必要に応じてBCPを見直す。",
                seq: 1,
                isSelected: false,
            },
            {
                columnName: 'N10061',
                value: callReplaceWord("組織") + "の構造変更",
                body: "合併、買収、新規事業の開始、人事異動、組織改編など、内部環境に大きな変化があった場合にBCPを見直す。",
                seq: 2,
                isSelected: false,
            },
            {
                columnName: 'N10061',
                value: "業務プロセスの変更",
                body: "業務プロセスの大幅な変更など、内部環境に大きな変化があった場合にBCPを見直す。",
                seq: 3,
                isSelected: false,
            },
            {
                columnName: 'N10061',
                value: "サプライチェーンや主要パートナーの変更",
                body: "主要なサプライヤー、サービスプロバイダー、パートナー企業の変更や破綻、またはサプライチェーンの大幅な再編成があった場合にBCPを見直す。",
                seq: 4,
                isSelected: false,
            },
            {
                columnName: 'N10061',
                value: "設備や技術の導入・更新",
                body: "新しいシステム、ソフトウェア、ハードウェア、設備の導入や既存技術の更新が行われた場合にBCPを見直す。",
                seq: 5,
                isSelected: false,
            },
            {
                columnName: 'N10061',
                value: "法規制や業界標準の変更",
                body: "法律や業界の規制、標準、ガイドラインが変更された場合にBCPを見直す。",
                seq: 6,
                isSelected: false,
            },
            {
                columnName: 'N10061',
                value: "組織の財務状況の変化",
                body: "重大な財務状況の変化（経済状況の悪化、予算の大幅な削減、資金繰りの変化など）があった場合にBCPを見直す。",
                seq: 7,
                isSelected: false,
            },
            {
                columnName: 'N10061',
                value: "新たなリスクの出現やリスク評価の変化",
                body: "新しい脅威やリスク（自然災害の頻度増加、サイバー攻撃の増加、パンデミックなど）が明らかになった場合、または既存のリスク評価が変化した場合にBCPを見直す。",
                seq: 8,
                isSelected: false,
            },
            {
                columnName: 'N10061',
                value: "BCP訓練で問題点が発見された場合や実際の緊急対応後のフィードバック",
                body: "BCPの訓練や演習を実施した結果、問題や改善点が見つかった場合。または実際の緊急対応後に得られた教訓や問題点を反映するために見直す。",
                seq: 9,
                isSelected: false,
            },
            
        ]);

        const valueForms = ref([]);
        const valueFormsInitialData = reactive([
            {
                columnName: 'N00056',
                values:[
                    {value: ''},
                    {value: '毎年1回'},
                    {value: callReplaceWord('従業員') + 'に対して、BCPの進捗状況や問題点を説明する'},
                ]
            },
            {
                columnName: 'N00057',
                values:[
                    {value: ''},
                    {value: '毎年1回'},
                    {value: callReplaceWord('製造') + '工程の変更に伴うBCPへの影響について、' +callReplaceWord('工場') + '内の' + callReplaceWord('従業員') + 'と共有化する'},
                ]
            },
            {
                columnName: 'N00058',
                values:[
                    {value: ''},
                    {value: '毎年1回'},
                    {value: 'BCPのポイントに関する' + callReplaceWord('社内') + '工研修会を開催する'},
                ]
            },
            {
                columnName: 'N00059',
                values:[
                    {value: ''},
                    {value: '毎年1回'},
                    {value: callReplaceWord('従業員') + '各自のBCPの役割分担（' +callReplaceWord('社外') + 'との連絡担当 等）の定期的な確認を行う'},
                ]
            },
         ]);

        const addLine = () => {
            const lastColumnName = valueForms.value.slice(-1)[0].columnName;
            const columnNameNumber = parseInt(lastColumnName.substring(1));
            valueForms.value.push({
                columnName: 'N' + ('00000' + (columnNameNumber + 1)).slice(-5),
                values:[
                    {value: ''},
                    {value: ''},
                    {value: ''},
                ]
            });
        }

        const showBack = async () => {
            // BCPの運用を登録
            const result = await registerIntroduction8();

            if (result == '200') {
                // 前のページへ遷移
                sessionStorage.setItem('refresh', 'true');
                history.back();
            }
        }

        const showIntroductionComplete = async () => {
            // BCPの運用を登録
            const result = await registerIntroduction8();

            if (result == '200') {
                // 終了ページへ遷移
                const nextPageUrl = '/bcp/bcp_introduction/introduction_complete';
                location.href = nextPageUrl;
            }
        }

        const showContents = async () => {
            // BCPの運用を登録
            const result = await registerIntroduction8();

            if (result == '200') {
                // 目次ページへ遷移
                const url = '/bcp/bcp_introduction/目';
                location.href = url;
            }
        }

        // BCPの運用の登録
        const registerIntroduction8 = async() => {
            // リクエストの整形
            const reqValueForms = [];
            valueForms.value.forEach(data => {
                data.values.forEach((val, index) => {
                    if (val.value != '') {
                        reqValueForms.push({
                            columnName: data.columnName,
                            seq: index + 1,
                            value: val.value,
                        });
                    }
                });
            });

            const reqTextForms = [];
            reqTextForms.push({
                columnName: "N00061",
                value: textOther.value,
            });
            //新画面構成変更に伴い空白とする
            reqTextForms.push({
                columnName: "N00062",
                value: "",
            });
            reqTextForms.push({
                columnName: "N00063",
                value: "",
            });
            // textForms.forEach(data => {
            //     reqTextForms.push({
            //         columnName: data.columnName,
            //         value: data.value,
            //     });
            // });

            //BCPを見直す基準
            const reqStandardForms = [];
            let wkArray = [];
            wkArray = textForms.filter(item=> item.isSelected === true);

            wkArray.forEach(data => {
                reqStandardForms.push({
                    columnName: data.columnName,
                    seq: data.seq,
                    value: data.value,
                })
            })


            const postUrl = '/api/bcp/registerIntroduction8';
            isProcessing.value = true;

            return await axios.post(postUrl, {
                'bcp_id': props.bcp_basic_frame_info.id,
                'version': props.bcp_basic_frame_info.version,
                'text_form_list': reqTextForms,
                'value_form_list': reqValueForms,
                'value_to_column_name': valueToColumnName,
                "standard_form_list": reqStandardForms,
            }).then(res => {
                // visibleFlashMessage('正常に登録されました', 'success');
                console.log(res);
                return res.status;
            }).catch(err => {
                console.log(err);
                return err.response?.status;
            }).finally(fin => {
                isProcessing.value = false;
            });
        }

        const confirm_button_label = ref("初版の作成年月日へ");

        const deleteLine = (index) => {
            if(!confirm((index + 1) + "番目の教育計画を削除します。よろしいですか？")){
                return false;
            }

            valueForms.value.splice(index, 1);

        }

        const selectedStandard = (index) => {
            textForms[index].isSelected = !textForms[index].isSelected ? true : false;
        }

        const textOther = ref("");

        return {
            setLevel,
            textForms,
            valueForms,
            valueFormsInitialData,
            isProcessing,
            selectAdminCandidate,
            callReplaceWord,
            addLine,
            showBack,
            showIntroductionComplete,
            showContents,
            confirm_button_label,
            deleteLine,
            selectedStandard,
            textOther,
        }
    },
    props:{
        corp_info: {
            type: Object,
        },
        replacement_word_list: {
            type: Array,
        },
        bcp_basic_frame_info: {
            type: Object,
        },
        bcp_introduction_texts_info: {
            type: Object,
        },
        bcp_introduction_values_info: {
            type: Object,
        },
        admin_candidate_list: {
            type: Array,
        },
    },
}
</script>

<style lang="scss" scoped>
@use '../../../../sass/common_colors.scss';

    .font-orange {
        color: common_colors.colors(resilience-orange);
    }

    .bg-sub-title {
        background-color: #f4b084;
    }
    .bg-one-set {
        background-color: #D9D9D9;
    }
    .btn.text-left {
        text-align: left;
    }
    .first-line {
        display: inline-block;
    }
    .second-line {
        display: inline-block;
        text-indent: 20px; /* インデントの幅を調整できます */
    }
    .button-selected {
        background-color: #c6c7c8;
    }
    .bg-other-title {
        background-color: #f8f9fa;
    }
    .centered {
        display: flex;
        align-items: center; /* 縦方向の中央揃え */
    }
</style>
